/*eslint-disable no-script-url*/
/*global gtag*/
import React, { Component } from 'react';
import { Actions } from './Actions';
import * as Common from '../components/Common';
import banner from '../images/Event/2018진짜공부_popup.png';

class EventPop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isImageload: false
    }
  }

  doEnterEvent () {
    gtag('event', '링크', {'event_category': this.props.banner.title, 'event_label': '링크'});
    Common.doMoveBannerLink(this.props.banner);
    Actions.doEventPopClose(false);
  }

  handleImageLoaded() {
    this.setState({ isImageload: true });
  }

  renderContents() {
    return (
      <div className="event-bottom">
        <div className="left"><a href={null} onClick={() => { Actions.doEventPopClose(true); } }>오늘 하루 보지 않기</a></div>
        <div className="right"><a href={null} onClick={() => { Actions.doEventPopClose(false); } }>닫기</a></div>
      </div>
    )
  }

  render() {
    return (
      <div className="layer-eventpop">
        <div className="bg"></div>
        <div className="contents">
          <a href={null} target={"_" + this.props.banner.target} rel="noopener noreferrer" onClick={() => this.doEnterEvent()}><img src={this.props.banner.bannerImgUrl} alt="" onLoad={this.handleImageLoaded.bind(this)} /></a>
          {this.state.isImageload ? this.renderContents() : null}
        </div>
      </div>
    )
  }
}

export default EventPop;